/*@ngInject*/
const BaseModalController = function ($scope) {

    // these should all be on this and not scope since
    // they are in a component controller. then the below code would be this.onConfirm etc
    $scope.onConfirm = function () {
        $scope.$ctrl.onConfirm();
    };

    $scope.onConfirmButtonUrlClick = function (event) {
        if (_.isUndefined(this.$ctrl.confirmButtonUrl) || this.$ctrl.confirmButtonUrl === '') {
            event.preventDefault();
        }
    };

    $scope.onCancelClick = function () {
        $scope.$ctrl.onCancel();
    };

    $scope.onThirdButtonClick = function () {
        $scope.$ctrl.onThirdButton();
    };

    $scope.canEnableConfirmButton = function () {
        if (_.isUndefined($scope.$ctrl.canEnableConfirmButton)) {
            return true;
        } else {
            return $scope.$ctrl.canEnableConfirmButton();
        }
    };

    $scope.displayCancelButton = function () {
        if (_.isUndefined(this.$ctrl.cancel) || this.$ctrl.cancel === '') {
            return false;
        }
        return true;
    };

    $scope.displayThirdButton = function () {
        if (_.isUndefined(this.$ctrl.thirdButton) || this.$ctrl.thirdButton === '') {
            return false;
        }
        return true;
    };
};

angular.module('umCore')
    .controller('baseModalController', BaseModalController);
